// Терминальный статус опроса платежа: им пользуются и заголовки диалогов
// вокруг PaymentStatusStep (PaymentDialog, PaymentStatusDialog,
// pages/product/[id].tsx), чтобы не разъезжаться с ним. REFUNDED появляется
// у полностью возвращённого платежа: usePayment прекращает опрос на любом
// не-PENDING статусе, и без этой ветки возврат к ?paymentId= такого платежа
// вис бы на спиннере.
export type TerminalStatus = "SUCCEEDED" | "CANCELED" | "REFUNDED" | "ERROR";

const TERMINAL_STATUSES: readonly string[] = [
  "SUCCEEDED",
  "CANCELED",
  "REFUNDED",
];

/** Статус платежа (или сорванный опрос) → терминальный статус для родителя;
 * null, пока ждём. */
export function resolveTerminalStatus(
  status: string | undefined,
  failed: boolean,
): TerminalStatus | null {
  if (status && TERMINAL_STATUSES.includes(status)) {
    return status as TerminalStatus;
  }
  return failed ? "ERROR" : null;
}
